angular.module('pitch.app', [
    'pitch.playlist',
    'pitch.playlist.pitch',
    'pitch.search',
    'pitch.media',
    'pitch.track',
    'satv.login',
    'satv.mediastats',
    'ui.router',
    'ui.router.metatags',
    'ngAnimate',
    'fc-presentation',
    'angular-google-analytics',
    'cfp.hotkeys',
    'satv.player'
], function($interpolateProvider) {
    $interpolateProvider.startSymbol('[[');
    $interpolateProvider.endSymbol(']]');
})

//add the config values to the constants
.constant('config', app_config)

.config(function($stateProvider, $urlRouterProvider, $urlMatcherFactoryProvider, $locationProvider, $logProvider, config, UIRouterMetatagsProvider, AnalyticsProvider) {

    //template helper
    function tpl(t) {
        return config.templateRoot + '/' + t + '?version=' + config.app_release_id;
    }

    // ----- METATAGS
    // https://github.com/tinusn/ui-router-metatags

    UIRouterMetatagsProvider
        // .setTitlePrefix('prefix - ')
        // .setTitleSuffix(' | Sony/ATV')
        // .setDefaultTitle('Sony/ATV')
        // .setDefaultDescription('description')
        // .setDefaultKeywords('keywords')
        .setStaticProperties({
                // 'fb:app_id': 'your fb app id',
                'og:site_name': 'Sony/ATV'
            })
        // .setOGURL(true)
    ;

    //metatags helper
    function ArticleMetaTags(article, image) {
        var data = {
            title: '[[' + article + '.title]]',
            description: '[[' + article + '.introduction]]',
            keywords: '[[' + article + '.keywords]]',
            properties: {
                'og:title': '[[' + article + '.title]]',
                'og:type': 'article',
                'og:description': '[[' + article + '.introduction]]'
            }
        };

        if (image) {
            data.properties['og:image'] = '[[' + article + '.assets.' + image + '.src]]';
        }

        return data;
    }

    $locationProvider.html5Mode(true).hashPrefix('!');

    $urlRouterProvider.otherwise('/');

    $logProvider.debugEnabled(config.env !== 'prod');

    //a sort of dataconverter to sanitize names etc.
    $urlMatcherFactoryProvider.type('slug', {
        encode: function(item) {
            if (item) {
                return item.toLowerCase().replace(/ /g, '-');
            }
        },
        decode: function(item) {
            return item;
        },
        is: function(item) {
            return true;
        }
    });



    $stateProvider

        //@todo check if this redirect is SEO friendly...
        .state('landing', {
            url: "/",
            controller: function($state, Locale) {
                $state.go('home', {
                    lang: Locale.get()
                });
            }
        })

        .state('root', {
            url: "/{lang:(?:" + config.languages.join('|') + ")}",
            abstract: true,
            template: '<div ui-view=""></div>',
            params: {
                lang: function(Locale) {
                    return Locale.get();
                }
            }
        })

        .state('home', {
            url: "",
            templateUrl: tpl('templates/home'),
            controller: 'HomeCtrl',
            parent: 'root',
            resolve: {
                statementSlides: function(ContextContentsLoader) {
                    //preload the statement images as they affect rendering
                    return new ContextContentsLoader(function(r) {
                        return {
                            sortField: 'slot',
                            sortOrder: 'ASC',
                            featured: true,
                            section: 'home/carousel, home/carousel:sites/' + r.id,
                            pageSize: 5
                        };
                    });
                },
                featuredPlaylists: function(ContextContentsLoader) {
                    //preload the featured playlists as they affect rendering
                    return new ContextContentsLoader(function(r) {
                        return {
                            sortField: 'slot',
                            sortOrder: 'ASC',
                            featured: true,
                            section: 'home/featured-playlists, home/featured-playlists:sites/' + r.id,
                            pageSize: 2
                        };
                    });
                }
            },
            metaTags: {
                title: 'Sony/ATV - The world’s No. 1 music publishing company',
                description: 'Sony/ATV is the world’s No. 1 music publishing company and prides itself' +
                    ' on housing the greatest collection of songs in the world. On behalf of our family' +
                    ' of artists and songwriters we make it our mission to ensure their songs live forever',
                keywords: 'Music Publishing',
                properties: {
                    'og:title': 'Sony/ATV',
                    'og:description': 'Sony/ATV is the world’s No. 1 music publishing company and prides itself' +
                        ' on housing the greatest collection of songs in the world. On behalf of our family' +
                        ' of artists and songwriters we make it our mission to ensure their songs live forever',
                keywords: 'Music Publishing',
                    'og:image': '/img/logo.png'

                }
            }
        })

        .state('about', {
            url: "/about",
            templateUrl: tpl('templates/about'),
            controller: 'AboutCtrl',
            parent: 'root',
            resolve: {
                statementSlides: function(ContextContentsLoader) {
                    return new ContextContentsLoader(function(r) {
                        return {
                            sortField: 'slot',
                            sortOrder: 'ASC',
                            featured: true,
                            section: 'about/carousel, about/carousel:sites/' + r.id,
                            pageSize: 5
                        };
                    });
                },
                articles: function(ContextContentsLoader) {
                    return new ContextContentsLoader(function(r) {
                        return {
                            sortField: 'slot',
                            sortOrder: 'ASC',
                            featured: true,
                            details: true,
                            section: 'about/text, about/text:sites/' + r.id
                        };
                    });
                }
            },
            metaTags: {
                title: 'About Sony/ATV',
                description: '',
                properties: {
                    'og:title': 'About Sony/ATV',
                    'og:description': '',
                    'og:image': '/img/logo.png'

                }
            }
        })

        .state('services', {
            url: "/services",
            templateUrl: tpl('templates/services'),
            controller: 'ServicesCtrl',
            parent: 'root',
            resolve: {
                statementSlides: function(ContextContentsLoader) {
                    return new ContextContentsLoader(function(r) {
                        return {
                            sortField: 'slot',
                            sortOrder: 'ASC',
                            featured: true,
                            section: 'services/carousel, services/carousel:sites/' + r.id,
                            pageSize: 5
                        };
                    });
                },
                articles: function(ContextContentsLoader) {
                    return new ContextContentsLoader(function(r) {
                        return {
                            sortField: 'slot',
                            sortOrder: 'ASC',
                            featured: true,
                            details: true,
                            section: 'services/text, services/text:sites/' + r.id
                        };
                    });
                }
            },
            metaTags: {
                title: 'Services by Sony/ATV',
                description: '',
                properties: {
                    'og:title': 'Services by Sony/ATV',
                    'og:description': '',
                    'og:image': '/img/logo.png'

                }
            }
        })

        .state('synch', {
            url: "/synch?{play:int}",
            templateUrl: tpl('templates/synch'),
            controller: 'SynchCtrl',
            parent: 'root',
            resolve: {
                articles: function(ContextContentsLoader) {
                    return new ContextContentsLoader(function(r) {
                        return {
                            sortField: 'slot',
                            category: 'synch',
                            type: 'article',
                            sortOrder: 'ASC',
                            featured: true,
                            details: true,
                            section: 'synch/text, synch/text:sites/' + r.id
                        };
                    });
                },
                videos: function(ContextContentsLoader) {
                    return new ContextContentsLoader(function(r) {
                        return {
                            category: 'synch',
                            type: 'video',
                            featured: true,
                            section: 'synch/featured-videos, synch/featured-videos:sites/' + r.id,
                            pageSize: 5,
                            details: true
                        };
                    });
                }
            },
            metaTags: {
                title: 'Synch',
                description: '',
                keywords: '',
                properties: {
                    'og:title': 'Synch',
                }
            }
        })

        .state('contact', {
            url: "/contact",
            templateUrl: tpl('templates/contact'),
            parent: 'root',
            controller: 'ContactCtrl',
            metaTags: {
                title: 'Contact',
                properties: {
                    'og:title': 'Contact',
                }
            }
        })

        // ---------- Songwriters

        .state('songwriters', {
            url: "/songwriters?char&page",
            templateUrl: tpl('templates/songwriters'),
            controller: 'SongwritersCtrl',
            parent: 'root',
            resolve: {
                contentsLoader: function(ContentsLoader, $stateParams) {
                    return new ContentsLoader({
                        textQuery: $stateParams.char,
                        category: 'songwriter',
                        sortField: 'title',
                        sortOrder: 'ASC',
                        pageSize: 50
                    });
                }
            },
            metaTags: {
                title: 'Featured Songwriters',
                properties: {
                    'og:title': 'Featured Songwriters',
                }
            }
        })

        .state('songwriterProfile', {
            url: "/songwriters/:id/{name:slug}",
            templateUrl: tpl('templates/songwriters/profile'),
            controller: 'SongwriterProfileCtrl',
            parent: 'root',
            resolve: {
                songwriter: function($stateParams, ContentLoader) {
                    return ContentLoader({
                        id: $stateParams.id
                    });
                }
            },
            metaTags: ArticleMetaTags('songwriter', 'thumbnail')
        })

        // ---------- News pages

        .state('news', {
            url: "/news",
            templateUrl: tpl('templates/news'),
            controller: 'NewsCtrl',
            parent: 'root',
            metaTags: {
                title: 'Latest news of Sony/ATV',
                description: '',
                keywords: '',
                properties: {
                    'og:title': 'Latest news of Sony/ATV'
                }
            }
        })

        .state('newsArticle', {
            url: "/news/:id/{name:slug}",
            templateUrl: tpl('templates/news-article'),
            controller: 'NewsArticleCtrl',
            parent: 'root',
            resolve: {
                article: function($stateParams, ContentLoader) {
                    return ContentLoader({
                        id: $stateParams.id
                    });
                }
            },
            metaTags: ArticleMetaTags('article', 'thumbnail')

        })

        //***** Playlists

        .state('featuredPlaylist', {
            url: "/playlists/featured/:id/{title:slug}",
            templateUrl: tpl('templates/playlists/featured'),
            controller: 'FeaturedPlaylistCtrl',
            parent: 'root',
            resolve: {
                content: function($stateParams, ContentLoader) {
                    return ContentLoader({
                        id: $stateParams.id
                    });
                }
            },
            metaTags: {
                title: 'Playlist [[content.subject.name]]',
                description: '[[content.subject.description]]',
                keywords: 'Featured playlist',
                properties: {
                    'og:title': 'Featured playlist [[content.subject.name]]',
                }
            }
        })

        // ---------- authentication

        .state('logout', {
            url: "/logout",
            controller: 'LogoutCtrl'
        })

        .state('login', {
            url: "/login",
            controller: 'LoginCtrl'
        })

        .state('termsAndConditions', {
            url: "/terms-and-conditions",
            parent: 'root',
            templateUrl: tpl('templates/legal/terms-and-conditions'),
            metaTags: {
                title: 'Terms & Conditions',
                properties: {
                    'og:title': 'Terms & Conditions',
                }
            }
        })

        .state('privacyPolicy', {
            url: "/privacy-policy",
            parent: 'root',
            templateUrl: tpl('templates/legal/privacy-policy'),
            metaTags: {
                title: 'Privacy Policy',
                properties: {
                    'og:title': 'Privacy Policy',
                }
            }
        })

        .state('cookiePolicy', {
            url: "/cookie-policy",
            parent: 'root',
            templateUrl: tpl('templates/legal/cookie-policy'),
            metaTags: {
                title: 'Cookie Policy',
                properties: {
                    'og:title': 'Cookie Policy',
                }
            }
        })

        .state('missingRoyalties', {
            url: "/missing-royalties",
            parent: 'root',
            templateUrl: tpl('templates/legal/missing-royalties'),
        })

        .state('changeOfAddress', {
            url: "/change-of-address",
            parent: 'root',
            templateUrl: tpl('templates/legal/change-of-address'),
            metaTags: {
                title: 'Change of Address',
                properties: {
                    'og:title': 'Change of Address',
                }
            }
        })

        .state('error', {
            url: "/error",
            parent: 'root',
            templateUrl: tpl('templates/error/error'),
            metaTags: {
                title: 'Error',
                properties: {
                    'og:title': 'Error',
                }
            }
        })

        .state('emipoland', {
            url: "/emi",
            templateUrl: tpl('templates/emipoland'),
            controller: 'EMIPolandCtrl'
        })
    ;

    if (config.ga) {
        AnalyticsProvider.setAccount(config.ga);
        AnalyticsProvider.setPageEvent('$stateChangeSuccess');
    } else {
        AnalyticsProvider.startOffline(true);
    }
})

.run(function(hotkeys, $state, fcDropnavCtrl, Player) {
    hotkeys.add({
        combo: 'ctrl+m',
        callback: function(e, hotkey) {
            e.preventDefault();
            $state.go('myMusic.playlists');
        }
    });
    hotkeys.add({
        combo: 'ctrl+s',
        callback: function(e, hotkey) {
            e.preventDefault();
            $state.go('search');
        }
    });
    hotkeys.add({
        combo: 'escape',
        callback: function(e, hotkey) {
            e.preventDefault();
            fcDropnavCtrl.hide();
        }
    });
    hotkeys.add({
        combo: 'space',
        callback: function(e, hotkey) {
            if (typeof Player.pause() !== "undefined") {
                Player.pause();
            }
        }
    });
})

.run(function($rootScope, $state, config, $anchorScroll, $timeout) {

    //scroll top top after route change
    $rootScope.$on('$stateChangeSuccess', function(event) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;

        $timeout(function() {
             if (document.activeElement.id !== 'skip-to-main-content') {
                 var element = document.getElementById('wrapper-navbar');
                 angular.element(element).css('display', 'block');
                 element.focus();
                 angular.element(element).css('display', 'none');
             }

        });

    });

    $rootScope.$on('$stateChangeError', function(event) {
        $state.go('error');
    });

    // JV redirects
    // This allows us to use jv configuration to override routes.
    $rootScope.$on('$stateChangeStart', function(event, toState) {
        if (config.jv && config.jv["routing.redirect"] && config.jv["routing.redirect"][toState.name]) {
            event.preventDefault();
            console.info('Jv config caused redirect');
            $state.go(config.jv["routing.redirect"][toState.name], {}, {reload: true});
        }
    });

    $rootScope.$on('FC_DROPNAV_IS_OPEN', function(event, isOpen) {
        $rootScope.isOpen = isOpen;
    });

    $rootScope.isOpen = false;
})

;



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/app.js